import React from "react";
import {useTranslation} from "react-i18next";
import SegmentedControl from "@awsui/components-react/segmented-control";
import { useAuth } from "hooks/useAuth";
import { isAdminEmail } from "common/adminEmails";


const LeagueSelector: React.FC = () => {

    const {t} = useTranslation("leagues");
    const [{ user, league }, dispatch] = useAuth();

    return (
        <SegmentedControl
            selectedId={`${league?.leagueId}`}
            onChange={({ detail }) => {
                const newLeague = user?.leagues?.find(league => league.leagueId === parseInt(detail.selectedId, 10));
                dispatch({
                    user: user,
                    isSignedIn: true,
                    // Server-side admin check lives in backend; this is UI-only.
                    isAdmin: isAdminEmail(user?.email),
                    league: newLeague
                });
            }}
            label={t("leagueSelectorLabel")}
            options={user?.leagues?.map(league => ({
                id: `${league.leagueId}`,
                text: league.name
            })) || []}
        />
    );
};

export default LeagueSelector;
